import toast from "react-hot-toast";
import { IUser } from "../Interfaces/user";

export const handleSetUserInLocalStorage = (user: IUser): void => {
  localStorage.setItem("user", JSON.stringify(user));
};

export const handleGetUserFromLocalStorage = (): string | null => {
  return localStorage.getItem("user");
};

export const handleRemoveUserFromLocalStorage = (): void => {
  localStorage.removeItem("user");
};

export const logout = (): void => {
  handleRemoveUserFromLocalStorage();
  toast.success("Logged Out");
  setTimeout(() => {
    window.location.href = "/";
  }, 500);
};

window.addEventListener("storage", () => {
  const currentUser = handleGetUserFromLocalStorage();
  if (currentUser != null) {
    if (currentUser === undefined) {
      logout();
    }
  }
});
